import { apiPath } from '../../constants';
import {
    axios,
    apiRequestOptions,
    errorRequestHandler,
    transformHttpResponse,
} from 'utils';

export const COMPETITION_PARTICIPANTS_REQUEST = 'FETCH_COMPETITION_PARTICIPANTS_REQUEST';
export const COMPETITION_PARTICIPANTS_FAILURE = 'FETCH_COMPETITION_PARTICIPANTS_FAILURE';
export const COMPETITION_PARTICIPANTS_SUCCESS = 'FETCH_COMPETITION_PARTICIPANTS_SUCCESS';

export const fetchCompetitionParticipants = (competitionId) => {
    return function(dispatch) {
        dispatch({ type: COMPETITION_PARTICIPANTS_REQUEST, competitionId });
        return axios(apiRequestOptions(apiPath.PARTICIPANT.LIST, { 'application.competition': competitionId }))
            .then(transformHttpResponse)
            .then(response => dispatch({ type: COMPETITION_PARTICIPANTS_SUCCESS, data: response.data, competitionId }))
            .catch(error => transformHttpResponse(error.response))
            .catch(error => {
                dispatch({ type: COMPETITION_PARTICIPANTS_FAILURE, competitionId });
                dispatch(errorRequestHandler(error));
            });
    }
};
